module.exports = __webpack_public_path__ + "img/ED4630_791A0E_A42716_501009-256px.02ab0661.png";